import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import AppActions from '../../actions/app-actions';
import { clearAllRetryTimers } from '../../utils/retrytimer';
import Global from '../settings/global';
import DeviceGroups from './device-groups';
import PendingDevices from './pending-devices';
import RejectedDevices from './rejected-devices';
import PreauthDevices from './preauthorize-devices';
import DeviceHistory from './device-history';
import AddDevice from './add-device';

const routes = {
  pending: {
    route: '/devices/pending',
    status: 'pending',
    title: 'Unauthorized'
  },
  preauthorized: {
    route: '/devices/preauthorized',
    status: 'preauthorized',
    title: 'Authorized'
  },
  rejected: {
    route: '/devices/rejected',
    status: 'rejected',
    title: 'Blacklisted'
  },
  history: {
    route: '/devices/history',
    status: 'history',
    title: 'History'
  },
  devices: {
    route: '/devices',
    status: 'devices',
    title: 'Device groups'
  },
  add: {
    route: '/devices/add',
    status: 'add',
    title: 'New Device'
  }
};

export default class Devices extends React.PureComponent {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();

    /** Bind methods */
    this._openSettingsDialogBind = this._openSettingsDialog.bind(this);
    this._changeTabBind = this._changeTab.bind(this);
  }

  componentDidMount() {
    clearAllRetryTimers();
  }

  componentWillUnmount() {
    clearAllRetryTimers();
  }
  _getInitialState() {
    return {
      currentTab: this._getCurrentLabel(),
      tabIndex: this._updateActive(),
      //pendingCount: AppStore.getTotalPendingDevices(),
      pendingCount: 0,
    };
  }

  _changeTab() {
    AppActions.setSnackbar('');
  }
  /*
   * Get counts of devices
   */
  // nested tabs
  UNSAFE_componentWillReceiveProps() {
    this.setState({ tabIndex: this._updateActive(), currentTab: this._getCurrentLabel() });
  }

  _updateActive(tab = this.context.router.route.match.params.status) {
    if (routes.hasOwnProperty(tab)) {
      return routes[tab].route;
    }
    return routes.devices.route;
  }

  _getCurrentLabel(tab = this.context.router.route.match.params.status) {
    if (routes.hasOwnProperty(tab)) {
      return routes[tab].title;
    }
    return routes.devices.title;
  }

  dialogToggle(ref) {
    var state = {};
    state[ref] = !this.state[ref];
    this.setState(state);
  }

  _redirect(route) {
    var self = this;
    self.setState({ openDeviceExists: false });
    self.context.router.history.push(route);
  }

  _openSettingsDialog() {
    var self = this;
    self.setState({ openIdDialog: !self.state.openIdDialog });
  }

  render() {
    // nested tabs
    var duplicateActions = [
      <div key="duplicate-action-button-1" style={{ marginRight: '10px', display: 'inline-block' }}>
        <Button onClick={() => this.dialogToggle('openDeviceExists')}>Cancel</Button>
      </div>
    ];
    const pendingLabel = this.state.pendingCount ? `${routes.pending.title} (${this.state.pendingCount})` : `${routes.pending.title}`;
    const tabIndex = this.context.router.route.match.params.status || 'devices';
    return (
      <div style={{ marginTop: '-15px' }}>
        <Tabs value={tabIndex} onChange={this._changeTabBind}>
          <Tab component={Link} label={routes.devices.title} value={routes.devices.status} to={routes.devices.route} />
          <Tab component={Link} label={pendingLabel} value={routes.pending.status} to={routes.pending.route} />
          <Tab component={Link} label={routes.preauthorized.title} value={routes.preauthorized.status} to={routes.preauthorized.route} />
          <Tab component={Link} label={routes.rejected.title} value={routes.rejected.status} to={routes.rejected.route} />
          <Tab component={Link} label={routes.history.title} value={routes.history.status} to={routes.history.route} />
          <Tab component={Link} label={routes.add.title} value={routes.add.status} to={routes.add.route} />
        </Tabs>
        {tabIndex === routes.pending.status && (
          <PendingDevices
            openSettingsDialog={this._openSettingsDialogBind}
          />
        )}
        {tabIndex === routes.preauthorized.status && (
          <PreauthDevices
            openSettingsDialog={this._openSettingsDialogBind}
          />
        )}
        {tabIndex === routes.rejected.status && (
          <RejectedDevices
            openSettingsDialog={this._openSettingsDialogBind}
          />
        )}
        {tabIndex === routes.history.status && (
          <DeviceHistory />
        )}
        {tabIndex === routes.devices.status && (
          <DeviceGroups
            params={this.props.params}
            redirect={this.props.redirect}
            openSettingsDialog={this._openSettingsDialogBind}
          />
        )}
        {tabIndex === routes.add.status && (
          <AddDevice />
        )}
        <Dialog open={this.state.openDeviceExists || false}>
          <DialogTitle>Device with this identity data already exists</DialogTitle>
          <DialogContent style={{ overflow: 'hidden' }}>
            <p>This will remove the group from the list. Are you sure you want to continue?</p>

            <p>
              A device with matching identity data already exists. If you still want to accept {pluralize('this', this.state.duplicates)} unauthorized{' '}
              {pluralize('device', this.state.duplicates)}, you should first remove the following {pluralize('device', this.state.duplicates)}:
            </p>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="columnHeader" tooltip="ID">
                    ID
                  </TableCell>
                  <TableCell className="columnHeader" tooltip="Status">
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(this.state.duplicates || []).map(function(device) {
                  var status = device.status === 'accepted' ? '' : `/${device.status}`;
                  return (
                    <TableRow hover key={device.device_id}>
                      <TableCell>
                        <a onClick={() => this._redirect(`/devices${status}/id%3D${device.device_id}`)}>{device.device_id}</a>
                      </TableCell>
                      <TableCell className="capitalized">{device.status}</TableCell>
                    </TableRow>
                  );
                }, this)}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>{duplicateActions}</DialogActions>
        </Dialog>

        <Dialog open={this.state.openIdDialog || false}>
          <DialogTitle>Default device identity attribute</DialogTitle>
          <DialogContent style={{ overflow: 'hidden' }}>
            <Global dialog={true} closeDialog={this._openSettingsDialogBind} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
